<template>
  <transition mode="out-in">
    <primary-button
      v-if="!show"
      white
      pure-icon
      :text="$t('SEARCH_CONTRACT_ID_OR_NOTE')"
      @click="show = true"
    >
      <template slot="icon">
        <font-awesome-icon :icon="faSearch" />
      </template>
    </primary-button>
    <text-input
      class="search"
      @keydown.enter="search"
      v-else
      :placeholder="$t('SEARCH_CONTRACT_ID_OR_NOTE')"
      v-model="searchInput"
      icon-position="right"
      rounded-edge
      with-shadow
      borderless
    >
      <template v-slot:icon>
        <font-awesome-icon @click="cancel" class="icon" :icon="faTimes" />
      </template>
    </text-input>
  </transition>
</template>

<script>
import { onMounted, ref } from '@vue/composition-api';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PrimaryButton from '@/components/PrimaryButton';
import TextInput from '@/components/TextInput';

const { useState, useActions } = createNamespacedHelpers('cashLog');

export default {
  name: 'Search',
  components: {
    FontAwesomeIcon,
    PrimaryButton,
    TextInput,
  },
  setup() {
    const { filters } = useState(['summary', 'filters']);
    const { applyFilter } = useActions(['getSummary', 'applyFilter']);

    const show = ref(false);
    const searchInput = ref('');

    const search = () => {
      applyFilter({
        search: searchInput.value,
      });
    };

    const cancel = () => {
      searchInput.value = '';
      applyFilter({
        search: null,
      });
      show.value = false;
    };

    onMounted(() => {
      if (filters.value.search !== null) {
        show.value = true;
        searchInput.value = filters.value.search;
      }
    });

    return {
      show,
      searchInput,
      search,
      cancel,
      faSearch,
      faTimes,
    };
  },
};
</script>

<style lang="scss" scoped>
.search {
  &.input {
    width: 230px;
  }
}

.icon {
  cursor: pointer;
}

.v-leave {
  opacity: 1;
}
.v-leave-active {
  transition: opacity .2s;
}
.v-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
.v-enter {
  opacity: 0;
}
.v-enter-active  {
  transition: opacity .1s
}
.v-enter-to {
  transform: translateX(10px);
  opacity: 1;
}
</style>
